import http from '@/api/http';

export default {
  //登录
  getLogin: (opts = {}) => {
    return http.post('/host/manage/v1/auth/login', {
      body: {
        oid: opts.oid,
        password: opts.password,
      },
    });
  },

  //上传图片
  uploadImage: formData => {
    return http.post('/upload/v1/ops/file/single', {
      body: formData,
      header: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};
